import { BehaviorSubject } from 'rxjs';

export const TableSettingsSubject$ = new BehaviorSubject([]);

export const getTableSettings$ = () => TableSettingsSubject$;
export const setTableSettings$ = (tableSettings: any) => TableSettingsSubject$.next(tableSettings);
